import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/_services/common.service';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ManageMappingService {

    constructor(private commonService: CommonService,
        readonly userInfoService: UserInfoService, private http: HttpClient) { }

    assignUsers(role, userid) {
        let headers = { headers: { 'Accept-Version': 'V1', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
        return this.commonService.postCall(environment.API_BASE_PATH + `/tenant/assignUser/${userid}`, { roles: [role] }, headers);
    }

    assignGroup(data: any, roleName) {
        let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
        return this.commonService.postCall(environment.API_BASE_PATH + `/tenant/role/${roleName}`, { groups: data.successor }, headers);
    }

    assignRole(data: any, groupName) {
        let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
        return this.commonService.postCall(environment.API_BASE_PATH + `/tenant/group/${groupName}`, { roles: data.successor }, headers);
    }

    groupRetrival(roleName) {
        let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
        return this.http.get(environment.API_BASE_PATH + `/tenant/group/role/${roleName}`, headers)
    }

    roleRetrival(groupName) {
        let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
        return this.http.get(environment.API_BASE_PATH + `/tenant/role/group/${groupName}`, headers)
    }

    assignGroupToUserId(data, userId) {
        let headers = { headers: { 'Accept-Version': 'V1', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
        return this.commonService.postCall(environment.API_BASE_PATH + `/tenant/assignUser/${userId}`, { groups: data.successor , roles:[]}, headers);
    }

    assignRolesToUserId(data, userId) {
        let headers = { headers: { 'Accept-Version': 'V1', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
        return this.commonService.postCall(environment.API_BASE_PATH + `/tenant/assignUser/${userId}`, { roles: data.successor }, headers);
    }

    groupHierarchy() {
        let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
        return this.commonService.getCall(environment.API_BASE_PATH + `/tenant/group/hierarchy`, headers);
    }

    getUserByGroup(index, rows, column, direction, search, userType) {
        let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID,'starting_index': String(index), 'max_rows': String(rows), 'sort_by': String(column), 'sort_dir': String(direction), 'search': String(search) } };
        return this.commonService.getCall(environment.API_BASE_PATH + `/tenant/user/group/${userType}`, headers);
    }

    getUserTypeBasedList(index, rows, column, direction, search, userType, isAll) {
        let headers = { headers: { 'starting_index': String(index), 'max_rows': String(rows), 'sort_by': String(column), 'sort_dir': String(direction), 'search': String(search), 'user_type': String(userType),'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };

        return isAll ? this.commonService.getCall(environment.API_BASE_PATH + '/users/findall', headers) :
            this.getUserByGroup(index, rows, column, direction, search, userType);
    }
    
    assignUserToGroup(groupName,userID) {
        let headers = { headers: { 'Accept-Version': 'V1', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
        return this.commonService.postCall(environment.API_BASE_PATH + `/tenant/assignUser/${userID}`, { groups: [groupName], roles:[] }, headers);
    }

    groupInfo() {
        let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
        return this.commonService.getCall(environment.API_BASE_PATH + `/tenant/group/info`, headers);
    }

}